import React from 'react'
import { Navigate } from 'react-router-dom'
import { useBilling } from '../../context/billingContext'

interface FeatureGuardProps {
	children: React.ReactNode
	requiredFeature: number
	redirectTo?: string
}

const FeatureGuard: React.FC<FeatureGuardProps> = ({
	children,
	requiredFeature,
	redirectTo = '/home',
}) => {
	const { hasFeature } = useBilling()

	if (!hasFeature(requiredFeature)) {
		return <Navigate to={redirectTo} replace />
	}

	return <>{children}</>
}

export default FeatureGuard
